import { useEffect, useState } from "react";

// Types
import { RecipeFieldTypes } from "src/types/contentfulTypes";

// Components
import RecipeCard from "src/components/molecules/recipeCard/RecipeCard";

// CSS
import "./RecipeList.scss";

interface RecipeListProps {
  recipes: RecipeFieldTypes[] | [];
}

const RecipeList = ({ recipes }: RecipeListProps) => {
  return (
    <ul className="recipe-list">
      {recipes.map((recipe: RecipeFieldTypes) => (
        <RecipeCard key={recipe.id} recipe={recipe} />
      ))}
    </ul>
  );
};

export default RecipeList;
